import clsx from 'clsx'
import { useCallback } from 'react'
import { Link } from 'react-router-dom'

import { ApiAccountDashboardNote } from '@/api'
import { Checkbox } from '@/components/core-v2/atoms/checkbox'
import { PATH } from '@/const'

import classes from './index.module.scss'

interface Props extends Pick<ApiAccountDashboardNote, 'noteId' | 'noteName'> {
  isChecked: boolean
  isSelected: boolean
  setCheckedNoteIds: React.Dispatch<React.SetStateAction<Set<string>>>
}

export const NoteCard = ({ isChecked, isSelected, noteId, noteName, setCheckedNoteIds }: Props) => {
  const onChange = useCallback(
    e => {
      e.preventDefault()
      e.stopPropagation()
      setCheckedNoteIds(noteIds => {
        const newState = new Set(noteIds)
        if (isChecked) {
          newState.delete(noteId)
        } else {
          newState.add(noteId)
        }

        return newState
      })
    },
    [isChecked, noteId, setCheckedNoteIds]
  )

  return (
    <li>
      <Link
        className={clsx(classes.item, { [classes.selected]: isSelected })}
        to={PATH.reportsSingleNote(noteId, 'details')}
      >
        <span className={classes.noteName}>{noteName}</span>
        <span className={classes.noteId}>{noteId}</span>
        <Checkbox
          key={`${noteId}-${isChecked}`}
          aria-label={noteName}
          checked={isChecked}
          onChange={onChange}
        />
      </Link>
    </li>
  )
}
